import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import ProductCard from '../ProductCard/ProductCard';
import TableRowItem from '../TableRowItem';
import TableColItem from '../TableColItem';
import { v4 as uuidv4 } from 'uuid';
import { ProductThumb } from '../../../../Components/Product/ProductThumb';
import { Tooltip } from '../../../../Components/Tooltip/Tooltip';
import { isReplaceProduct, isPinnedProduct } from '../../Ranking/utils';

const optionCssList = {
	gridTemplateColumns: '6fr 2fr 2f 2fr',
	userSelect: 'none',
};

const elementRanking = (elem,
	dimension,
	deletePromotedProduct,
	deleteDemotedProduct,
	rankingObject,
	shopifyPinnedProductsOfSelectedCategory,
	refs,
	deleteReplaceProductWithId,
	deletePinnedProductWithId,
) => {

	const Url = elem.url;
	const idTooltip = uuidv4();
	const idTooltipPin = uuidv4();
	const idTooltipSwap = uuidv4();
	const isReplace = isReplaceProduct(rankingObject.transformations, elem.id);
	const isPinned = isPinnedProduct(shopifyPinnedProductsOfSelectedCategory, elem.id);

	return (
		<>
			<Tooltip id={idTooltip} />
			<TableColItem>
				<div className="flex">
					<div className='flex_item_fix'>
						<i className="fas fa-grip-vertical"
							{...refs.listeners}
							data-for={idTooltip}
							data-tip={'Drag to sort'}
							style={{
								cursor: 'grab',
								display: 'flex',
								alignItems: 'start',
								marginRight: '4px'
							}}
						/>
					</div>
					<div className="flex_item_fix">
						<a className="emerch_avatar emerch_avatar_margin"
							href={Url}
							target="_blank"
							style={{ userSelect: 'none' }}
						>
							<ProductThumb
								alt={elem.id}
								url={elem.urlThumbnail}
								width={40}
							/>
						</a>
					</div>
					<div className='flex_item_full'>
						<p className="table_row_name">
							{elem.name}
						</p>
					</div>
				</div>
			</TableColItem>
			<TableColItem refs={refs} style={{cursor: 'grab'}}>
				<p>{elem.price}€</p>
			</TableColItem>

			<TableColItem style={{cursor: 'grab'}}>
				<p>{elem.id}</p>
			</TableColItem>
			<TableColItem align='right'>
				<div className='collection_list_status_wrapper'>
					{isReplace.isATransformationReplace &&
						<>
							<Tooltip id={idTooltipSwap} />
							<div className='collection_status' data-for={idTooltipSwap} data-tip={`Swapped with product: ${isReplace.replaceProductId}`}>
								<i className='fas fa-retweet' />
								<button className='collection_status_remove' onClick={() => deleteReplaceProductWithId(elem.id)}>
									<i className='fas fa-times'></i>	
								</button>
							</div>
						</>
					}
					{isPinned.pinned && isPinned.productWithPosition !== undefined &&
						<>
							<Tooltip id={idTooltipPin} />
							<div className='collection_status' data-for={idTooltipPin} data-tip={`Product pinned at position: ${isPinned.productWithPosition.position + 1}`}>
								<i className='fas fa-thumbtack' />
								<button className='collection_status_remove' onClick={() => deletePinnedProductWithId(elem.id)}>
									<i className='fas fa-times'></i>	
								</button>
							</div>
						</>
					}
					{dimension == 'promoted' &&
						<div className='collection_status' data-for={idTooltip} data-tip={'Promoted product. Click to reset.'}>
							<i className='fas fa-arrow-circle-up' />
							<button className='collection_status_remove'
								onClick={dimension === 'promoted' ? () => deletePromotedProduct(elem.id) : () => deleteDemotedProduct(elem.id)}>
								<i className='fas fa-times'></i>	
							</button>
						</div>
					}
					{dimension == 'demoted' &&
						<div className='collection_status' data-for={idTooltip} data-tip={'Demoted product. Click to reset.'}>
							<i className='fas fa-arrow-circle-down' />
							<button className='collection_status_remove'
								onClick={dimension === 'promoted' ? () => deletePromotedProduct(elem.id) : () => deleteDemotedProduct(elem.id)}>
								<i className='fas fa-times'></i>	
							</button>
						</div>
					}
				</div>
			</TableColItem>
		</>
	);
};

export const SortableCard = (props) => {

	const {
		idInClipBoard,
		copyToClipBoard,
		dimension,
		deletePromotedProduct,
		product,
		type,
		deleteDemotedProduct,
		rankingObject,
		shopifyPinnedProductsOfSelectedCategory,
		deleteReplaceProductWithId,
		deletePinnedProductWithId
	} = props;

	const {
		attributes,
		isDragging,
		listeners,
		setNodeRef,
		transform,
		transition
	} = useSortable({ id: product.id });

	const style = {
		transform: CSS.Transform.toString(transform),
		transition,
		zIndex: isDragging ? '1000' : 'auto',
		opacity: isDragging ? 0.5 : 1,
		color: isDragging && 'var(--btn-color-primary)',
		borderTop: isDragging && '1px solid var(--btn-color-primary)',
		borderBottom: isDragging && '1px solid var(--btn-color-primary)',
	};

	if (!product) {
		return <></>;
	}

	const isReplace = isReplaceProduct(rankingObject.transformations, product.id);
	const isPinned = isPinnedProduct(shopifyPinnedProductsOfSelectedCategory, product.id);

	if (type === 'grid') {
		return (
			<div
				style={{ ...style }}
				ref={setNodeRef}
				// {...props}
				{...attributes}
			>
				<ProductCard
					idInClipBoard={idInClipBoard}
					copyToClipBoard={(e) => copyToClipBoard(e)}
					deleteItemFunction={dimension === 'promoted' ? () => deletePromotedProduct(product.id) :
						() => deleteDemotedProduct(product.id)
					}
					isDraggableItem={true}
					key={product.id}
					product={product}
					dimension={dimension}
					inPromoteDemoteList={true}
					isReplace={isReplace}
					isPinned={isPinned}
					deleteReplaceProductWithId={deleteReplaceProductWithId}
					deletePinnedProductWithId={deletePinnedProductWithId}
				/>
			</div>
		);
	}

	const refs = {
		setNodeRef: setNodeRef,
		// props: props,
		attributes: attributes,
		listeners: listeners
	};

	return (
		<TableRowItem
			key={product.id}
			specialClasseName={'table_body_row'}
			styleObj={{ ...optionCssList, ...style }}
			isDraggableItem={true}
			refs={refs}
		>
			{elementRanking(
				product,
				dimension,
				deletePromotedProduct,
				deleteDemotedProduct,
				rankingObject,
				shopifyPinnedProductsOfSelectedCategory,
				refs,
				deleteReplaceProductWithId,
				deletePinnedProductWithId,
			)}
		</TableRowItem>
	);
};
